import { registerSW } from "virtual:pwa-register";

/**
 * Registers the service worker. With registerType: "autoUpdate" (set in
 * vite.config.ts), the underlying workbox-window registration already
 * reloads the page itself once a new version activates — otherwise an
 * already-open tab keeps running the old JS bundle in memory even after the
 * SW's cache updates in the background, so bug fixes silently don't take
 * effect until a user happens to hard-refresh, which isn't something a
 * household user would know to do.
 *
 * No-ops safely if the browser has no serviceWorker support, e.g. a plain
 * HTTP origin that isn't "localhost" (service workers require a secure
 * context) — the app still works fully online in that case, it just won't
 * support install/offline until TLS is added in front of it.
 */
export function registerServiceWorker(): void {
  registerSW({ immediate: true });
}
